var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "scheduler-modal-wrapper",
      class: { "scheduler-modal-wrapper--active": _vm.saveFeedResponse },
    },
    [
      [
        _c("mds-loader", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.modalLoading,
              expression: "modalLoading",
            },
          ],
          staticClass: "loader",
        }),
      ],
      _vm._v(" "),
      [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.modalLoading && !_vm.saveFeedResponse,
                expression: "!modalLoading && !saveFeedResponse",
              },
            ],
            staticClass: "scheduler-modal-wrapper",
            class: { active: _vm.saveFeedResponse },
          },
          [
            _vm.editedFeed
              ? _c(
                  "mds-button",
                  {
                    staticClass: "scheduler-modal__close",
                    attrs: {
                      variation: "icon-only",
                      icon: "remove",
                      type: "button",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("close", $event)
                      },
                    },
                  },
                  [_vm._v("\n        Close\n      ")]
                )
              : _vm._e(),
            _vm._v(" "),
            _c("scheduler-modal-header", {
              attrs: {
                editedFeed: _vm.editedFeed,
                "active-step": _vm.activeStep,
              },
              on: {
                "mds-step-activated": function ($event) {
                  _vm.activeStep = $event.step.id
                },
                "mds-step-clicked": function ($event) {
                  _vm.activeStep = $event.id
                },
                "stepper-click": _vm.onStepperClick,
              },
            }),
            _vm._v(" "),
            _c(
              "scheduler-modal-content",
              _vm._g(
                {
                  attrs: {
                    "source-step-info": _vm.sourceStepInfo,
                    "parameters-step-info": _vm.parametersStepInfo,
                    "format-step-info": _vm.formatStepInfo,
                    "delivery-step-info": _vm.deliveryStepInfo,
                    "source-type": _vm.sourceType,
                    "data-set-type": _vm.dataSetType,
                    "stepper-id": _vm.activeStep,
                    "without-feed-name": _vm.emptyFeedName,
                    "investment-id": _vm.investmentId,
                    "holdings-entitlements": _vm.holdingsEntitlements,
                  },
                  on: {
                    input: _vm.addParametersToForm,
                    name: function ($event) {
                      _vm.addParameterToForm($event, "job_name")
                      _vm.name = $event
                    },
                    "source-type": function ($event) {
                      _vm.addParameterToForm($event, "investment_object_type")
                      _vm.sourceType = $event
                    },
                    "source-data-set-type": function ($event) {
                      _vm.addParameterToForm($event, "data_set_type")
                      _vm.dataSetType = $event
                    },
                    validName: function ($event) {
                      _vm.validName = $event
                    },
                    "disable-save-button": function ($event) {
                      _vm.disabledSaveButtons = $event
                    },
                    "attestation-check": function ($event) {
                      _vm.attestationCheck = $event
                    },
                  },
                },
                _vm.$listeners
              )
            ),
            _vm._v(" "),
            _c("scheduler-modal-buttons", {
              attrs: {
                "active-step": _vm.activeStep,
                "disabled-next-button": _vm.disableNextButton,
                "disabled-save-buttons":
                  _vm.disabledSaveButtons || !_vm.isValidName,
                "disabled-edit-button": _vm.selectedParamsChanged,
              },
              on: {
                "back-step": function ($event) {
                  _vm.activeStep -= 1
                },
                "next-step": function ($event) {
                  _vm.activeStep += 1
                },
                save: _vm.createOrSchedule,
                close: function ($event) {
                  return _vm.$emit("close", $event)
                },
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("scheduler-modal-save-response", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.saveFeedResponse,
              expression: "saveFeedResponse",
            },
          ],
          attrs: {
            type: "feed",
            "save-status": _vm.saveFeedStatus,
            "has-duplicate-name": _vm.hasDuplicateName,
            "error-loading-parameters": _vm.errorLoadingParameters,
            "attestation-check": _vm.isAttestationChecked,
          },
          on: {
            save: _vm.createOrSchedule,
            close: _vm.closeModal,
            retry: _vm.reload,
            "change-name": _vm.onChangeName,
          },
        }),
      ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }